import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import buildUrl from 'lib/buildUrl';
import { content as ContentPropType } from 'lib/CustomPropTypes';

import LeadBorderTop from 'components/LeadBorderTop';
import Link from 'components/Link';
import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import ContentTimestamp from 'components/ContentTimestamp';
import TeaseCategory from 'components/TeaseCategory';
import AIMS_FLAVORS from 'lib/aimsFlavors';

import styles from './styles.module.scss';

// TODO, detach this from TeaseCard (props, isNative())
class LeadSquare extends TeaseCard {
  author() {
    const { content } = this.props;

    if (content.type === 'article'
        && content.item
        && content.item.authors
        && content.item.authors[0]) {
      return <div className="black">{ content.item.authors[0].person.name }</div>;
    }

    return null;
  }

  byline() {
    const author = this.author();
    const date = this.date();

    const bylineToolkitClasses = ['founders-mono', 'f2', 'lh-copy', 'ls-tight', 'gray-80', 'mv3'];

    if (!author && !date) {
      return null;
    }

    return (
      <div className={classNames(styles.byline, bylineToolkitClasses)}>
        { author }
        { date }
      </div>
    );
  }

  date() {
    const { content: { type, item, metadata = {} } } = this.props;

    if (type !== 'article' || !metadata.showTimestamp) {
      return null;
    }

    const { dateCreated, datePublished } = item;

    return (
      <div>
        <ContentTimestamp
          dateCreated={dateCreated}
          datePublished={datePublished}
          layout="split"
        />
      </div>
    );
  }

  dek() {
    const { content: { computedValues } } = this.props;

    return <p className={styles.dek}>{computedValues.dek}</p>;
  }

  render() {
    const { content, packageId, pkgClassName } = this.props;
    if (!content) { return null; }

    const {
      id: contentId, type, computedValues, packageIndex,
    } = content;
    const unibrow = computedValues ? computedValues.unibrow : content.unibrow;

    const url = buildUrl(content);

    const containerClasses = classNames(
      pkgClassName,
      packageIndex && `pkg-index-${packageIndex + 1}`,
      styles.leadSquare,
      {
        [styles.sponsored]: this.isNative(),
      },
    );

    const contentClasses = classNames(
      styles.content,
      this.props.styles.content,
      'layout-grid-item',
    );

    const infoClasses = classNames(
      styles.info,
      this.props.styles.info,
      'clearfix',
    );

    const titleToolkit = ['pl5', 'p0-m'];

    return (
      <section data-packageid={packageId} data-test="lead-square__container" className={containerClasses}>
        <LeadBorderTop types={['collectionLead']} />
        <div className="layout-grid-container" data-contentid={contentId}>
          <article className={contentClasses}>
            <h2 className={classNames(styles.title, titleToolkit)}>
              <Link to={url}>
                {computedValues.headline}
              </Link>
            </h2>

            <div className={styles.picture}>
              <Link to={url}>
                <TeasePicture
                  responsiveFlavors={{
                    s: AIMS_FLAVORS.FOCAL_758x379,
                    m: AIMS_FLAVORS.FOCAL_920x460,
                    l: AIMS_FLAVORS.FOCAL_460x460,
                    xl: AIMS_FLAVORS.FOCAL_580x580,
                  }}
                  type={type}
                  computedValues={computedValues}
                  placeholder
                />
              </Link>
            </div>

            <div className={styles.category}>
              <TeaseCategory
                type={type}
                unibrow={unibrow}
                style={this.getCategoryStyle()}
                iconUrl={url}
              />
            </div>

            <div className={infoClasses}>
              {this.byline()}
              {this.dek()}
            </div>
          </article>
        </div>
      </section>
    );
  }
}

LeadSquare.propTypes = {
  content: ContentPropType,
  pkgClassName: PropTypes.string,
};

LeadSquare.defaultProps = {
  pkgClassName: 'pkg leadSquare',
};

export default LeadSquare;
